import styled from 'styled-components';
import Image from 'gatsby-image';
var ImageWrapper = styled(Image).withConfig({
  displayName: "ImageWrapper",
  componentId: "sc-1om61c5-0"
})(["flex:1;"]);
export default ImageWrapper;